module.exports = __webpack_public_path__ + "img/bakingIcon.6bdfadf8.png";